/** Shared field contract for model-facing schemas and command preflight. */
export const PROCESS_OPERATION_FIELDS = {
  insert_step: { required: ['label', 'from', 'to'], optional: ['lane', 'stepKind'] },
  add_step: { required: ['label'], optional: ['after', 'lane', 'stepKind'] },
  connect: { required: ['from', 'to'], optional: [] },
  disconnect: { required: ['from', 'to'], optional: [] },
  rename: { required: ['target', 'label'], optional: [] },
  remove_step: { required: ['target'], optional: [] },
} as const;
export type ProcessOperationName = keyof typeof PROCESS_OPERATION_FIELDS;
const fields: Record<string, Record<string, unknown>> = {
  label: { type: 'string', minLength: 1, description: 'Exact new step label, or replacement label for rename.' },
  from: { type: 'string', minLength: 1, description: 'Existing source step ID or unambiguous label. Put from directly beside op.' },
  to: { type: 'string', minLength: 1, description: 'Existing target step ID or unambiguous label. Put to directly beside op.' },
  target: { type: 'string', minLength: 1, description: 'Step ID or unambiguous label to rename/remove. Never choose an ID to resolve a duplicate label without user selection or explicit user ID.' },
  after: { type: 'string', minLength: 1, description: 'Optional: use only for a user-requested after attachment. Omit for an unconnected new step or when a later connect operation creates that same edge. Adds only the incoming flow; preserves existing flows.' },
  lane: { type: 'string', minLength: 1, description: 'Requested swimlane label; does not draw or place a lane pool.' },
  stepKind: { type: 'string', enum: ['task', 'decision', 'start', 'end'], description: 'New step kind; omit for task.' },
};
export const PROCESS_OPERATION_SCHEMA = {
  anyOf: Object.entries(PROCESS_OPERATION_FIELDS).map(([op, contract]) => ({
    type: 'object',
    properties: {
      op: { type: 'string', enum: [op] },
      ...Object.fromEntries([...contract.required, ...contract.optional].map(field => [field, fields[field]])),
    },
    required: ['op', ...contract.required],
    additionalProperties: false,
  })),
};
